var RecentSearches = React.createClass({
  propTypes: {
    searches: React.PropTypes.arrayOf(React.PropTypes.string),
    className: React.PropTypes.string
  },
  render() {
    let {className} = this.props;
    className = classNames(className, {"bullet-list": className == undefined});

    return (
      <ul className={className} aria-hidden={!this.props.searches.length}>
        {this.props.searches.map((queryText, i) =>
          <li key={i}>
            <a href={RA.buildSearchUrl(queryText)}>{queryText}</a>
          </li>
        )}
      </ul>
    )
  }
})